import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { DashSelection } from '../app/app.model';
import { graphData, guage, kosten, durchsatz, störfälle } from './content.model'
import AreaService from './content.service';

@Component(
    {
        name: 'content_area',
        components: {
            guagechart: require("../guagechart/guagechart.vue.html").default,
            areachart: require("../areachart/areachart.vue.html").default,
            barchart: require("../columnchart/columnchart.vue.html").default,
            incidentsTable: require("../table/table.vue.html").default
        }
    }
)
export default class ContentAreaComponent extends Vue {
    @Prop({ required: true })
    selection!: DashSelection;

    service: AreaService = new AreaService();
    guages: guage[] = [];
    costs: graphData<kosten> = new graphData<kosten>();
    throughput: graphData<durchsatz> = new graphData<durchsatz>();
    incidents: graphData<störfälle> = new graphData<störfälle>();

    mounted() {
        this.reload();
    }

    @Watch('selection', { deep: true })
    private onSelectionChanged(): void {
        this.reload();
    }

    private async reload(): Promise<void> {
        await this.fetchGuages(this.selection.machine, this.from, this.to);
        await this.fetchCost(this.selection.machine, this.from, this.to);
        await this.fetchThroughput(this.selection.machine, this.from, this.to);
        await this.fetchIncidents();
    }

    private async fetchGuages(machine: string, from: number, to: number) {
        let guages = await this.service.fetchGuages(machine, new Date(from), new Date(to));
        this.guages.splice(0);
        this.guages.push(...guages);
        console.log('gauges', this.guages);
    }

    private async fetchCost(machine: string, from: number, to: number) {
        this.costs = await this.service.fetchCost(machine, new Date(from), new Date(to));
        console.log('costs', this.costs);
    }

    private async fetchThroughput(machine: string, from: number, to: number) {
        this.throughput = await this.service.fetchThroughput(machine, new Date(from), new Date(to));
        console.log('throughput', this.throughput);
    }

    private async fetchIncidents() {
        this.incidents = await this.service.fetchIncidents();
        console.log('incidents', this.incidents);
    }

    private formatDate(): string {
        let d = this.selection.startDate,
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [day, month, year].join('.');
    }

    private get from(): number {
        return this.selection.startDate.getTime();
    }

    private get to(): number {
        let to = new Date(this.selection.startDate);
        switch (this.selection.duration) {
            case 'day':
                to.setDate(to.getDate() + 1);
                break;
            case 'week':
                to.setDate(to.getDate() + 7);
                break;
            case 'month':
                to.setMonth(to.getMonth() + 1);
                break;
        }
        return to.getTime();
    }
}